exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-spinner{color:#333}.sk-spinner>div{background-color:currentColor}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/react-spinkit/css/base.css
// module id = 1079
// module chunks = 17